import { createSelector } from "reselect";
import { Operation } from "../../models/types/Operation";

const operation = (state: { operation: Operation }) => state.operation;

// My Operation
const selectOperationInfos = createSelector(operation, (operation) => operation && operation.operationInfos);

const selectOperations = createSelector(operation, (operation) => operation.operations);


const selectFilter = createSelector(operation, (operation) => operation.filter);

const selectSorting = createSelector(selectFilter, (filter) => filter.sorting);

const selectLatestDateWithData = createSelector(operation, (operation) => operation && operation.latestDateWithData);

const selectType = createSelector(selectFilter, (filter) => filter.participantType);

// TODO handle error when we will use this function
/*const selectParticipantsAndObservers = createSelector(
    selectSelectedOperation,
    selectType,
    (operation, type) => {
        let participants = [];
        if (operation) {
            const data = {
                consumers: operation[participantsFilterTypes.CONSUMERS].map((consumer: { name: any; billingDetail: { name: any; }; enedisDetail: { prm: any; }; }) => {
                    const name = consumer.name ? consumer.name : consumer.billingDetail ? consumer.billingDetail.name : consumer.enedisDetail ? consumer.enedisDetail.prm : '';
                    return { ...consumer, name, isConsumer: true };
                }),
                producers: operation[participantsFilterTypes.PRODUCERS].map((producer: { name: any; billingDetail: { name: any; }; enedisDetail: { padt: any; }; }) => {
                    const name = producer.name ? producer.name : producer.billingDetail ? producer.billingDetail.name : producer.enedisDetail ? producer.enedisDetail.padt : '';
                    return { ...producer, name, isProducer: true };
                }),
                observers: operation[participantsFilterTypes.OBSERVERS].map((observer: { name: any; }) => {
                    const name = observer.name ? observer.name : '';
                    return { ...observer, name, isObserver: true };
                }),
            };
            participants = operation ? type !== 'all' ?  data[type] :
                [...data.consumers, ...data.producers, ...data.observers] :
                [];
            participants.sort((a: { name: string; }, b: { name: any; }) => {
                return a.name.localeCompare(b.name) >= 0 ? 1 : -1;
            });
        }
        return participants;

    },
);*/



export {
    selectLatestDateWithData, selectOperationInfos, selectOperations,
    selectSorting,
    selectType
};

